import { render, staticRenderFns } from "./manageStudentList.vue?vue&type=template&id=53433254&scoped=true&"
import script from "./manageStudentList.vue?vue&type=script&lang=js&"
export * from "./manageStudentList.vue?vue&type=script&lang=js&"
import style0 from "./manageStudentList.vue?vue&type=style&index=0&id=53433254&prod&lang=scss&scoped=true&"
import style1 from "./manageStudentList.vue?vue&type=style&index=1&id=53433254&prod&lang=css&"
import style2 from "./manageStudentList.vue?vue&type=style&index=2&id=53433254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53433254",
  null
  
)

export default component.exports